import React,{useContext,useState} from 'react'
import {Row,Col,Button,Alert} from 'react-bootstrap'
import {IconContext} from 'react-icons'
import {FaUserAlt} from 'react-icons/fa'
import {MdPlace} from 'react-icons/md'
import {IoArrowBack} from 'react-icons/io5'
import {SiGooglescholar} from 'react-icons/si'
import {TiEdit} from 'react-icons/ti'
import {AiFillTag} from 'react-icons/ai'
import {RiUserSearchFill} from 'react-icons/ri'
import {BsHeartHalf,BsFillCalendarFill,BsChatSquareDotsFill} from 'react-icons/bs'
import Input from '../../../components/Input/index.js'
import Textarea from '../../../components/Textarea/index.js'
import AuthContext from '../../../context/AuthContext.js'
import PrefixContext from '../../../context/PrefixContext.js'
import { IKContext,IKUpload } from 'imagekitio-react';
import axios from 'axios'

function Index(props) {
    const AuthContextData = useContext(AuthContext);
    const PrefixContextData = useContext(PrefixContext);
    const [previewImage, setpreviewImage] = useState(null)
    const [internalState, setinternalState] = useState('DEFAULT')
    const defaultValidation = {
        validationStatus: null,
        validationStatusClass: null,
        validationStatusMessage: null,
    }
    const [validation,setValidation] = useState(defaultValidation);
    const [data, setdata] = useState({...props.about})

    const onChangeHandler = (e) =>{
        const newData = {
            ...data
        }
        newData[e.target.name]=e.target.value;
        setdata(newData);
    }

    const saveChanges = (e) =>{
        e.preventDefault();
        if (validation.validationStatusClass === 'warning') return;
        if( validation.validationStatus !== 'LOADING')
        {
            setValidation({
                validationStatus: 'LOADING',
                validationStatusClass:'warning',
                validationStatusMessage: 'Please wait updating ...',
                validationStatusLocation: 'DEFAULT'
            });
            axios.post(PrefixContextData.prefixUrl + 'data/edit/about/'+props.handlerID, data)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        validationStatusLocation: 'DEFAULT'
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                            validationStatusLocation: 'DEFAULT'
                        });
                    }
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        validationStatusLocation: 'DEFAULT'
                    });
                }
            });
        }
    }

    const editImageNameInDB = (res) =>{
        if(res.fileType === 'non-image')
        {
            setValidation({
                validationStatus: true,
                validationStatusClass:'danger',
                validationStatusMessage: 'Select a proper image (png,jpg,jpeg)',
                validationStatusLocation: 'IMAGE'
            });
        }
        else{
            const newData = {...data}
            newData.image= res.name;
            axios.post(PrefixContextData.prefixUrl + 'data/edit/about/'+props.handlerID, newData)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        validationStatusLocation: 'IMAGE'
                    });
                    if(response.data.successMessageDetails !== undefined && response.data.successMessageDetails.savedDataset !== undefined && response.data.successMessageDetails.savedDataset !== null)
                    {
                        props.refreshData(response.data.successMessageDetails.savedDataset)
                    }
                    setdata(newData)
                    setpreviewImage(null)
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                    else if(error.response.data !== undefined || error.response.data !== null){
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.response.data.errorMessage,
                            validationStatusLocation: 'IMAGE'
                        });
                    }
                    else{
                        setValidation({
                            validationStatus: true,
                            validationStatusClass:'danger',
                            validationStatusMessage: error.message,
                            validationStatusLocation: 'IMAGE'
                        });
                    }
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        validationStatusLocation: 'IMAGE'
                    });
                }
            });
        }
    }

    const onFileChangeHandler = (e) =>{
        setValidation({
            validationStatus: true,
            validationStatusClass:'warning',
            validationStatusMessage: 'Uploading Image ...',
            validationStatusLocation: 'IMAGE'
        });
        setpreviewImage(URL.createObjectURL(e.target.files[0]))
    }

    return(<>
        {internalState === 'DEFAULT' && <>
            <h5 className="py-3">Edit About Data</h5>
            {(validation.validationStatus !== null && validation.validationStatus !== undefined && validation.validationStatusLocation === 'DEFAULT')  && <div className="text-center">
                <Alert className="d-inline-block" variant={validation.validationStatusClass}>&nbsp;&nbsp;{validation.validationStatusMessage}</Alert>
            </div>}
            <div className="d-flex justify-content-end mb-3">
                <div className="d-flex align-items-center cursor-pointer text-primary" onClick={()=>setinternalState('IMAGE')}>
                    <TiEdit/> &nbsp;
                    <span>
                        Edit Image
                    </span>
                </div>
            </div>
            <Row className="align-items-center small-inputcomponent modal-container">
                <Col md="2" className="text-left d-none d-md-block">
                    <label>Name</label>
                </Col>
                <Col md="10">
                    <Input className="w-100" name="name" defaultValue={(data !== undefined) ? data.name : null}  onChangeHandler={onChangeHandler} placeholder="Name" icon={<FaUserAlt/>}/>
                </Col>
                <Col md="2" className="text-left d-none d-md-block">
                    <label>Age</label>
                </Col>
                <Col md="10">
                    <Input type="number" className="w-100" name="age" defaultValue={(data !== undefined) ? data.age : null} onChangeHandler={onChangeHandler} placeholder="Age" icon={<BsHeartHalf/>}/>
                </Col>
                <Col md="2" className="text-left d-none d-md-block">
                    <label>Date Of Birth</label>
                </Col>
                <Col md="10">
                    <Input className="w-100" name="dob" defaultValue={(data !== undefined) ? data.dob : null} onChangeHandler={onChangeHandler} placeholder="Date Of Birth" icon={<BsFillCalendarFill/>}/>
                </Col>
                <Col md="2" className="text-left d-none d-md-block">
                    <label>Gender</label>
                </Col>
                <Col md="10">
                    <Input className="w-100" name="gender" defaultValue={(data !== undefined) ? data.gender : null} onChangeHandler={onChangeHandler} placeholder="Gender" icon={<RiUserSearchFill/>}/>
                </Col>
                <Col md="2" className="text-left d-none d-md-block">
                    <label>BirthPlace</label>
                </Col>
                <Col md="10">
                    <Input className="w-100" name="birthplace" defaultValue={(data !== undefined) ? data.birthplace : null} onChangeHandler={onChangeHandler} placeholder="BirthPlace" icon={<MdPlace/>}/>
                </Col>
                <Col md="2" className="text-left d-none d-md-block">
                    <label>Course</label>
                </Col>
                <Col md="10">
                    <Input className="w-100" name="course" defaultValue={(data !== undefined) ? data.course : null} onChangeHandler={onChangeHandler} placeholder="Course" icon={<SiGooglescholar/>}/>
                </Col>
                <Col md="2" className="text-left d-none d-md-block">
                    <label>Title</label>
                </Col>
                <Col md="10">
                    <Input className="w-100" name="title" defaultValue={(data !== undefined) ? data.title : null} onChangeHandler={onChangeHandler} placeholder="Title" icon={<AiFillTag/>}/>
                </Col>
                <Col md="2" className="text-left d-none d-md-block">
                    <label>Description</label>
                </Col>
                <Col md="10">
                    <Textarea className="w-100" name="desc" defaultValue={(data !== undefined) ? data.desc : null} onChangeHandler={onChangeHandler} placeholder="Description" icon={<BsChatSquareDotsFill/>}/>
                </Col>
            </Row>
            <div className="d-flex p-3 justify-content-between">
                <Button variant='white' className="border border-black" onClick={props.goBack}>
                    <div className="d-flex align-items-center">
                        <IconContext.Provider value={{color:'#6c757d'}}>
                            <IoArrowBack/> &nbsp;
                        </IconContext.Provider>
                        <p className="text-secondary mb-0">Go Back</p>
                    </div>
                </Button>
                <Button className="px-3 py-2" onClick={(e)=>{saveChanges(e)}}>
                    <div className="d-flex align-items-center">
                        <p className="mb-0">Save Changes</p>
                    </div>
                </Button>
            </div>
        </>}
        {internalState === 'IMAGE' && <>
            <h5 className="py-3">Edit Resume Image</h5>
            {(validation.validationStatus !== null && validation.validationStatus !== undefined && validation.validationStatusLocation === 'IMAGE')  && <div className="text-center">
                <Alert className="d-inline-block" variant={validation.validationStatusClass}>&nbsp;&nbsp;{validation.validationStatusMessage}</Alert>
            </div>}
            <form encType="multipart/form-data">
                <div className="pt-3">
                    <Row>
                        <Col md="12">
                            <div className="d-flex justify-content-around">
                                <div>
                                <p>Exisiting Image</p>
                                {
                                    (data.image === undefined) ? 
                                    <img className="mb-3" src={PrefixContextData.cdnPrefixUrl + '/avtaar_A-JQZIHAe.png'} alt="Resume Profile" style={{height:'100px'}}/> :
                                    <img className="mb-3" src={PrefixContextData.cdnPrefixUrl + 'uploaded/'+data.image} alt="Resume Profile" style={{height:'140px'}}/>
                                }
                                </div>
                                <div className="text-center">
                                    <p>New Image</p>
                                    { previewImage === null ? <div style={{height:'140px'}} className="bg-secondary px-3"><small>No Image Selected</small></div> : <img style={{height:'140px'}} src={previewImage} alt="Upload Preview" /> }
                                </div>
                            </div>
                        </Col>
                        <hr className="my-4 mx-auto" style={{width:'90%'}}/>
                        <Col md="12" lg="8" className="mx-auto text-center">
                            <IKContext
                                authenticationEndpoint={PrefixContextData.prefixUrl + 'data/edit/imagekit/auth'}
                                urlEndpoint={PrefixContextData.ImageKiturlEndpoint}
                                publicKey={PrefixContextData.imageKitPublicKey}
                                >
                                    <IKUpload
                                        fileName="profile-image-upload.png"
                                        onError={()=>alert('There was an error uploading image please retry.')}
                                        onSuccess={(res)=>editImageNameInDB(res)}
                                        folder={"/Resume_Builder/uploaded"}
                                        onChange={onFileChangeHandler}
                                        accept="image/x-png,image/gif,image/jpeg"
                                        />
                            </IKContext>
                        </Col>
                    </Row>
                </div>
                <div className="d-flex py-4 justify-content-between">
                    <Button variant='white' className="border border-black" onClick={()=>{setpreviewImage(null);setinternalState('DEFAULT')}}>
                        <div className="d-flex align-items-center">
                            <IconContext.Provider value={{color:'#6c757d'}}>
                                <IoArrowBack/> &nbsp;
                            </IconContext.Provider>
                            <p className="text-secondary mb-0">Go Back</p>
                        </div>
                    </Button>
                </div>
            </form>
        </>}
    </>)

}

export default Index
